import axios from 'axios';
import { getItem } from '../utils/localStorage';

const token = getItem('token', '');

let baseURL = 'https://whatsappapi.consistem.com.br';

if (process.env.NODE_ENV === 'development') {
    baseURL = 'http://localhost:3001';
}

if (window.location.href.includes('wabamanagerhomo')) {
    baseURL = 'https://whatsapphomologacao.consistem.com.br';
}

const api = axios.create({
    baseURL: baseURL,
    headers: {
        common: {
            authorization: token,
        },
    },
});

export { baseURL, api };

// api.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//         let message = "Internal Server Error";

//         if (error.response.data?.message) {
//             message = error.response.data?.message;
//         }

//         console.error("Intercepter error", error.response.data);

//         return Promise.reject(message);
//     }
// );
